export default {
  en: {
    startTalking: 'Start a conversation',
  },
  ru: {
    startTalking: 'Начать разговор',
  },
};
